import api from "@/lib/api";

function urlBase64ToUint8Array(v) {
  const padding = "=".repeat((4 - (v.length % 4)) % 4);
  const b64 = (v + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(b64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export function pushSupported() {
  return typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    window.isSecureContext;
}

export async function enableWebPush() {
  if (!pushSupported()) throw new Error("Push not supported by this browser");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return false;
  const { data } = await api.get("/push/vapid-public-key");
  if (!data.public_key) throw new Error("Server has no VAPID key configured");
  await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
  }
  const json = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
  return true;
}

export async function disableWebPush() {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  try {
    await api.delete("/push/subscribe", { data: { endpoint: sub.endpoint } });
  } catch {}
  await sub.unsubscribe();
}

export async function pushStatus() {
  if (!pushSupported()) return { supported: false, subscribed: false };
  if (typeof Notification === "undefined" || Notification.permission !== "granted") {
    return { supported: true, subscribed: false, permission: Notification?.permission };
  }
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return { supported: true, subscribed: !!sub, permission: "granted" };
}
